<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Choose person</ion-title>
    <ion-buttons slot="end">
      @if (permissionService.isPermitted('pos-people-add-person')) {
        <ion-button (click)="presentAddPersonModal()">
          <fa-icon [icon]="['fas', 'plus']" size="lg" [fixedWidth]="true"></fa-icon>
        </ion-button>
      }
    </ion-buttons>
  </ion-toolbar>

  @if (!person) {
    <ion-toolbar>
      <ion-searchbar #search_bar_input placeholder="Search for a person" debounce="200" [(ngModel)]="query" (ionInput)="searchPeople()"></ion-searchbar>
    </ion-toolbar>
  }

</ion-header>

<ion-content>

  @if (person) {
    <div>
      <ion-item lines="full">
        <ion-label>
          @if (person.full_name) {
            <span>{{person.full_name}} (#{{person.number}})</span>
          }
          @if (!person.full_name) {
            <span>#{{person.number}}</span>
          }
        </ion-label>
        <fa-icon [icon]="['fal', 'times']" size="lg" (click)="clear()" slot="end"></fa-icon>
      </ion-item>
    </div>
  }

  @if (!person) {
    <div>
      @if (!loading && visible_people && visible_people.length != 0) {
        <ion-list>
          @for (person of visible_people; track person) {
            <ion-item lines="full" button="true" (click)="select(person.id)">
              <ion-label>
                @if (person.full_name) {
                  <span>{{person.full_name}} (#{{person.number}})</span>
                }
                @if (!person.full_name) {
                  <span>#{{person.number}}</span>
                }
              </ion-label>
            </ion-item>
          }
        </ion-list>
      }
      @if (visible_people && visible_people.length != 0) {
        <ion-infinite-scroll threshold="100px" (ionInfinite)="showMoreVisiblePeople($event)">
          <ion-infinite-scroll-content loadingSpinner="crescent" loadingText="Loading"></ion-infinite-scroll-content>
        </ion-infinite-scroll>
      }
    </div>
  }

  @if (visible_people && visible_people.length == 0) {
    <ion-grid class="nothing-found">
      <ion-row class="ion-align-items-center ion-justify-content-center">
        <ion-col>
          <p>
            <fa-icon [icon]="['fal', 'user']" size="6x"></fa-icon>
            <span>No people found</span>
          </p>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>
